export default class CreditsModal {
    constructor(container) {
        this.container = container;
        this.trigger = container.querySelector('[data-credits-open]');
        this.modal = container.querySelector('[data-credits-modal]');

        if (!this.trigger || !this.modal) return;

        // The footer is transformed by its scroll-reveal animation, and a
        // position:fixed element inside a transformed ancestor anchors to that
        // ancestor instead of the viewport. Move the modal to <body> so it sits
        // at the true bottom-right of the screen.
        document.body.appendChild(this.modal);

        this.closeBtn = this.modal.querySelector('[data-credits-close]');
        this.isOpen = false;

        this.bind();
    }

    bind = () => {
        this.trigger.addEventListener('click', this.toggle);
        this.closeBtn?.addEventListener('click', this.close);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
    };

    toggle = () => {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    };

    open = () => {
        this.isOpen = true;
        this.modal.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
    };

    close = () => {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.modal.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
    };

    // Close when clicking anywhere outside the modal or its trigger.
    onDocumentClick = (event) => {
        if (!this.isOpen) return;
        if (this.modal.contains(event.target) || this.trigger.contains(event.target)) return;
        this.close();
    };

    onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
    };
}
